import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomPagination from "../../components/CustomPagination";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BookingRsvpTable from "./bookingRsvpTable";
import AddNote from "../../Modals/addNote";
import CancelEventModal from "../../Modals/cancelEvent";
import { isValidInput, isValidNumber } from "../../utils/validations";
import {
  useLazyBookingDetailsQuery,
  useLazyGetNotesQuery,
  useRefundGuestMutation,
} from "../../service/booking";
import CloseIcon from "@mui/icons-material/Close";
import { showError, showToast } from "../../constants/toasts";
import { Booking } from "../../types/General";
import { formatDubaiDateTime } from "../../utils/dateTime";
import Loader from "../../constants/Loader";
import { BOOKING_STATUS, OFFER_TYPE } from "../../utils/enums";
import { GridColDef } from "@mui/x-data-grid";
import TableComponent from "../../components/TableComponent";
import DietaryRequirements from "../../Modals/dietaryRequirements";

const EVENT_TYPE = {
  PAID: "Paid",
  COMPLIMENTARY: "Complimentary",
};

const REFUND_STATUS = {
  REFUND_PENDING: "RefundPending",
  REFUNDED: "Refunded",
};

interface NotesType {
  id: string;
  note: string;
  employeeName: string;
  dateTime: string;
}
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function RsvpBookingDetail() {
  const { id } = useParams();
  const location = useLocation();
  const { state } = location;
  const status = state?.status || "";
  const categoryTab = state?.categoryTab || "";
  const categoryId = state?.categoryId || "";
  const cancel = state?.cancel || false;
  const isRefund = state?.isRefund || false;
  const isPast = state?.isPast || false;
  const transaction = state?.transaction || false;
  const internalStatus = state?.internalStatus || "";

  const [bookingDetails] = useLazyBookingDetailsQuery();
  const [getNotes] = useLazyGetNotesQuery();
  const [refundGuest] = useRefundGuestMutation();

  const [page, setPage] = useState(1);
  const searchParams = new URLSearchParams(location.search);
  const categoryType = searchParams.get("category");
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [bookingData, setBookingData] = useState<Booking | null>(null);
  const [loading, setLoading] = useState(false);
  const [notesData, setNotesData] = useState<NotesType[]>([]);
  const [openModal4, setOpenModal4] = React.useState(false);
  const [openModal5, setOpenModal5] = React.useState(false);
  const [selectedReason, setSelectedReason] = React.useState("");
  const [count, setCount] = useState(10);
  const [bookingGuests, setBookingGuests] = useState([]);
  const [refundOpen, setRefundOpen] = useState(false);
  const [refundAmount, setRefundAmount] = useState("");
  const [error, setError] = useState(false);
  const [guestEmail, setGuestEmail] = useState("");
  const [guestRole, setGuestRole] = useState("");

  const isEventBooking = bookingData?.offerDetails?.offerType === "Events";

  const hasNoGuests = bookingData?.guest === 0;
  const noExceptionalGuest = !bookingData?.isExceptionalGuestAdded;
  const notCancelled = !bookingData?.isCancel;
  const notPast = !isPast;

  const canAddExceptionalGuest =
    isEventBooking &&
    hasNoGuests &&
    noExceptionalGuest &&
    notCancelled &&
    notPast;

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };
  const navigate = useNavigate();
  const goBack = () => {
    if (!status && !categoryTab && !categoryId) {
      navigate(-1); // Go back if these values are missing
      return;
    }

    if (cancel) {
      navigate("/manage-cancellation", {
        state: { status, categoryTab, categoryId },
      });
    } else if (transaction) {
      navigate("/transactions", {
        state: { status },
      });
    } else {
      navigate("/manage-booking-resvp", {
        state: { status, categoryTab, categoryId },
      });
    }
  };

  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  const getBookingDetailsApi = async () => {
    try {
      setLoading(true);
      const response = await bookingDetails({ id }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setBookingData(response?.data || []);
        setBookingGuests(
          response?.data?.bookingUserDetails?.filter(
            (item: any) => item?.role !== "Partner"
          )
        );
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getNotesApi = async () => {
    try {
      setLoading(true);
      const response = await getNotes({
        id,
        page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setNotesData(response?.data?.items || []);
        setCount(response?.data?.totalCount);
      } else {
        setNotesData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const refundGuestApi = async () => {
    setError(true);
    if (!refundAmount) {
      return;
    }

    try {
      const body = {
        bookingId: bookingData?.id,
        refunduserDeails: [
          {
            email: guestEmail,
            role: guestRole,
            amount: refundAmount,
          },
        ],
      };

      setLoading(true);
      const response = await refundGuest(body).unwrap();
      setLoading(false);
      if (response.status === 200) {
        showToast(response?.message || "");
        onRefundClose();
        getBookingDetailsApi();
      } else {
        setNotesData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const formatAnswer = (q: any) => {
    switch (q?.inputType) {
      case "Checkbox":
        return q?.options
          .filter((opt: any) => q?.answer?.checkboxOptions?.includes(opt?.id))
          .map((opt: any) => opt?.optionText)
          .join(", ");

      case "Radio":
        return q?.options?.find(
          (opt: any) => opt?.id === q?.answer?.selectedOptionId
        )?.optionText;

      case "Text":
      case "TextArea":
        return q?.answer?.textValue;

      case "Date":
        return new Date(q?.answer?.textValue).toLocaleDateString();

      default:
        return "";
    }
  };

  const renderStatus = (status: any) => {
    switch (status) {
      case BOOKING_STATUS.NEW_BOOKING:
        return "New Booking";

      case BOOKING_STATUS.PENDING:
        return "In Progress";

      case BOOKING_STATUS.COMPLETE:
        return "Completed";

      case BOOKING_STATUS.CONFIRM:
        return "Confirmed";

      case BOOKING_STATUS.PENDING_CANCELLATION:
        return "Pending Cancellation";

      case BOOKING_STATUS.PENDING_PAYMENT:
        return "Pending Payment";

      case BOOKING_STATUS.CANCELLED:
        return "Cancelled";

      default:
        return "";
    }
  };

  const getStatusText = () => {
    if (bookingData?.refundDetails?.refundStatus === "Paid") return "Refunded";
    if (bookingData?.isCancel) return "Cancelled";
    if (
      !bookingData?.isCancel &&
      bookingData?.refundDetails?.refundStatus !== "Paid"
    )
      return renderStatus(internalStatus);
    return "";
  };

  const getStatusColor = () => {
    if (bookingData?.refundDetails?.refundStatus === "Paid") return "green";
    if (bookingData?.isCancel) return "red";
    return "white";
  };

  const onRefundClose = () => {
    setRefundOpen(false);
    setRefundAmount("");
    setError(false);
  };

  useEffect(() => {
    if (id) {
      getBookingDetailsApi();
    }
  }, []);

  useEffect(() => {
    if (valueTabs1 === 1) {
      getNotesApi();
    }
  }, [valueTabs1]);

  const columns: GridColDef[] = [
    {
      flex: 1,
      minWidth: 140,
      field: "name",
      headerName: "Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <div
            role="button"
            tabIndex={0}
            className="user_block click_action"
            onClick={() => navigate("/manage-employee/view")}
          >
            <p>
              <b>{row?.name || "-"}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 250,
      field: "email",
      headerName: "Email",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return <p>{row?.email || "-"}</p>;
      },
    },

    {
      flex: 2,
      minWidth: 300,
      field: "DietaryRequirements",
      headerName: "Dietary Requirements",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <p>
            {row?.dietaries?.length
              ? row?.dietaries?.map((i: any) => i?.name).join(" , ")
              : "-"}
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 180,
      field: "Payee",
      headerName: "payee",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return <p>{row?.payerName || "0"}</p>;
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "amount",
      headerName: "Amount",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return <p>AED {row?.amount || "0"}</p>;
      },
    },
    {
      flex: 1,
      minWidth: 120,
      field: "PaymentStatus",
      headerName: "Payment Status",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return <p>{row?.paymentStatus || "-"}</p>;
      },
    },
    {
      flex: 1,
      minWidth: 230,
      field: "payDate",
      headerName: "Payment Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }: any) => {
        return (
          <p>
            {row?.paymentDate ? formatDubaiDateTime(row?.paymentDate) : "-"}
          </p>
        );
      },
    },
  ];

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton onClick={() => goBack()}>
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              Booking Detail
            </h1>
          </div>
          <div className="right_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />

            <Button className="btn btn_primary">
              <img src="/static/images/filter_icon.svg" alt="icon" /> Filters
            </Button>
          </div>
        </div>

        <Box className="custom_tabs1 mb_30" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs1}
            onChange={handleChangeTabs1}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Booking Info" {...a11yProps(0)} />
            <Tab label="Notes" {...a11yProps(1)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={valueTabs1} index={0}>
          <div className="cards table_cards  v2">
            <div className="cards">
              <div className="section_title">
                <h2>{bookingData?.offerDetails?.categoryName || "-"}</h2>
                <div className="btn_flex">
                  {/* <Button className="btn btn_primary">Confirm</Button> */}
                  {categoryType !== "Experience" && (
                    <Button
                      className="btn btn_primary"
                      onClick={() =>
                        navigate(`/manage-booking-resvp/edit-history`, {
                          state: {
                            bookingId: bookingData?.id,
                            offerType: bookingData?.offerDetails?.offerType,
                            name: bookingData?.clientDetails?.name,
                            email: bookingData?.clientDetails?.email,
                            phone: bookingData?.clientDetails?.phoneNumber,
                            countryCode:
                              bookingData?.clientDetails?.countryDialCode,
                            dateCreated: bookingData?.createdDate,
                            category: bookingData?.offerDetails?.categoryName,
                            offerName: bookingData?.offerDetails?.title,
                            dietary: bookingData?.dietary,
                            employeeName: bookingData?.employeeName,
                            hashId: bookingData?.bookingId,
                          },
                        })
                      }
                    >
                      View Edit History
                    </Button>
                  )}
                  {canAddExceptionalGuest ? (
                    <Button
                      className="btn btn_primary"
                      onClick={() =>
                        navigate(
                          `/manage-booking-resvp/add-exceptional-guest`,
                          {
                            state: {
                              bookingId: bookingData?.id,
                              membershipType:
                                bookingData?.clientDetails?.memberShipType,
                            },
                          }
                        )
                      }
                    >
                      Add Exceptional Guest
                    </Button>
                  ) : null}
                  {categoryType === "Event" && (
                    <Button
                      className="btn btn_danger"
                      onClick={() => setOpenModal4(true)}
                    >
                      Cancel
                    </Button>
                  )}

                  <Button
                    className="btn btn_primary "
                    onClick={() => setOpen1(true)}
                  >
                    Add Note
                  </Button>

                  {!bookingData?.isCancel && !isPast ? (
                    <Button
                      className="btn btn_primary "
                      onClick={() =>
                        navigate(
                          `/manage-offer/preview-offer-detail/add-user?offerType=${bookingData?.offerDetails?.offerType}`,
                          {
                            state: {
                              isEdit: true,
                              offerId: bookingData?.offerDetails?.id,
                              bookingId: bookingData?.id,
                              questions: bookingData?.questions,
                              numberOfGuest: bookingData?.totalNumberofGuest,
                              eventType: bookingData?.offerDetails?.eventType,
                              isGuestAdded:
                                bookingData?.isGuestAdded ||
                                bookingData?.isExceptionalGuestAdded,
                              clientEmail: bookingData?.clientDetails?.email,
                              clientName: bookingData?.clientDetails?.name,
                              bookingDate: bookingData?.bookingDateTime,
                              specialRequest: bookingData?.specialRequest,
                              isPartnerAdded: bookingData?.isPartnerAdded,
                              guestDetails:
                                bookingData?.bookingUserDetails?.filter(
                                  (item: any) => item?.role !== "Partner"
                                ),
                              contactDealerAmount:
                                bookingData?.contactDealerAmount,
                              contactDealerNotes:
                                bookingData?.contactDealerNotes,
                            },
                          }
                        )
                      }
                    >
                      {" "}
                      <img src="/static/images/edit_icon.svg" alt="icon" /> Edit
                      Details
                    </Button>
                  ) : null}
                </div>
              </div>
              <div className="booking_top_detail">
                <ul className="order_head">
                  <li>
                    <h6>Booking ID</h6>
                    <p>{bookingData?.bookingId || "-"}</p>
                  </li>
                  <li>
                    {categoryType !== "Experience" && (
                      <>
                        <h6>Guests</h6>
                        <p>{bookingData?.totalNumberofGuest || "0"}</p>
                      </>
                    )}
                  </li>
                  <li>
                    <>
                      {" "}
                      <h6>Booking Date</h6>
                      <p>
                        {bookingData?.bookingDateTime
                          ? formatDubaiDateTime(bookingData?.bookingDateTime)
                          : "-"}
                      </p>
                    </>
                  </li>
                  <li>
                    <h6>Date Created</h6>
                    <p>
                      {bookingData?.createdDate
                        ? formatDubaiDateTime(bookingData?.createdDate)
                        : "-"}
                    </p>
                  </li>
                  <li>
                    <h6>Booking Status</h6>
                    <p style={{ color: getStatusColor() }}>{getStatusText()}</p>
                  </li>
                  {bookingData?.offerDetails?.offerType ===
                  OFFER_TYPE.EVENTS ? (
                    <li className="ml_auto">
                      {" "}
                      Type{" "}
                      <span className="btn_text dark c_success">
                        {bookingData?.offerDetails?.eventType || "-"}
                      </span>
                    </li>
                  ) : null}
                </ul>
                <div className="booking_bx v2">
                  <figure>
                    <img
                      src={bookingData?.offerImages[0]?.offerImageUrl}
                      alt="img"
                    />
                  </figure>
                  <div className="book_cnt">
                    <span className="tag">
                      {bookingData?.offerDetails?.categoryName || ""}
                    </span>
                    <h3
                      className="cursor_p"
                      onClick={() =>
                        navigate(
                          `/manage-offer/preview-offer-detail/${bookingData?.offerDetails?.id}`,
                          {
                            state: {
                              type:
                                bookingData?.offerDetails?.offerType === "event"
                                  ? "EVENT"
                                  : bookingData?.offerDetails?.offerType ===
                                      "experience"
                                    ? "EXPERIENCE"
                                    : "RESTAURANT",
                            },
                          }
                        )
                      }
                    >
                      {bookingData?.offerDetails?.title || "-"}
                    </h3>

                    <p>{bookingData?.offerDetails?.badge || "-"}</p>
                  </div>
                </div>
              </div>

              <div className="gap_p view_page">
                <div className="w_25">
                  <h6>Client Name</h6>
                  <p>{bookingData?.clientDetails?.name || "-"}</p>
                </div>
                <div className="w_25">
                  <h6>Client Email</h6>
                  <p>{bookingData?.clientDetails?.email || "-"}</p>
                </div>

                <div className="w_25">
                  <h6>Client Phone</h6>
                  <p>{`${bookingData?.clientDetails?.countryDialCode ? `+${bookingData?.clientDetails?.countryDialCode}` : ""} ${bookingData?.clientDetails?.phoneNumber || "-"}`}</p>
                </div>

                <div className="w_25">
                  <h6>Employee Name</h6>
                  <p>{bookingData?.employeeName || "-"}</p>
                </div>

                <div className="w_25">
                  <h6>Any special request or occassion</h6>
                  <p className="yellow">{bookingData?.specialRequest || "-"}</p>
                </div>

                <div className="w_25">
                  <h6>Dietary Requirements</h6>
                  <p>
                    {bookingData?.dietary?.length
                      ? bookingData?.dietary
                          ?.map((i: any) => i?.name)
                          .join(" , ")
                      : "-"}
                  </p>
                </div>

                {bookingData?.isExceptionalGuestAdded ? (
                  <div className="w_25">
                    <h6>Exceptional guests</h6>
                    <p>{bookingData?.numberofExceptionalGuest || "-"}</p>
                  </div>
                ) : null}

                {bookingData?.questions?.map((q) => (
                  <div className="w_25">
                    <h6>{q?.label || "-"}</h6>
                    <p>{formatAnswer(q) || ""}</p>
                  </div>
                ))}
              </div>
              {bookingData?.offerDetails?.offerType === "Events" && (
                <>
                  {bookingData?.bookingUserDetails?.filter(
                    (item: any) => item.role === "Partner"
                  )?.length ? (
                    <div className="control_group w_100">
                      <hr />
                    </div>
                  ) : null}

                  {/* Partner Detail */}
                  {bookingData?.bookingUserDetails
                    ?.filter((item: any) => item.role === "Partner")
                    .map((partner: any, idx: number) => (
                      <div key={partner.id}>
                        <div className="section_title mb_20">
                          <h2>Partner Detail</h2>
                        </div>

                        <div className="gap_p view_page">
                          <div className="control_group w_25">
                            <h6>Name</h6>
                            <p>{partner?.name || "-"}</p>
                          </div>
                          <div className="control_group w_25">
                            <h6>Email</h6>
                            <p>{partner?.email || "-"}</p>
                          </div>

                          <div className="control_group w_25">
                            <h6>Dietary Requirements</h6>
                            <p>
                              {partner?.dietaries
                                ? partner?.dietaries
                                    ?.map((i: any) => i?.name)
                                    .join(" , ")
                                : "-"}
                            </p>
                          </div>

                          {bookingData?.offerDetails?.eventType ===
                          EVENT_TYPE.PAID ? (
                            <div className="control_group w_25">
                              <h6>Payment Status</h6>
                              <p>
                                {partner?.paymentStatus} -{" "}
                                <strong
                                  className={
                                    partner?.paymentStatus === "Paid"
                                      ? "c_success"
                                      : "c_pending"
                                  }
                                >
                                  AED {partner.amount || 0}
                                </strong>
                              </p>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ))}
                </>
              )}

              {bookingData?.isCancel ? (
                <>
                  {bookingData?.offerDetails?.offerType ===
                    OFFER_TYPE.RESTAURANT && !isRefund ? (
                    <>
                      <div className="control_group w_100">
                        <hr />
                      </div>
                      <div className="section_title mb_20">
                        <h2>Canceled Details</h2>
                      </div>
                      <div className="gap_p view_page">
                        <div className="control_group w_25">
                          <h6>Charge Type</h6>
                          <p>Yes</p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Charge Amount</h6>
                          <p>
                            AED{" "}
                            {bookingData?.cancellationDetails?.amount || "0"}
                          </p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Charge Status</h6>
                          <p>
                            {bookingData?.cancellationDetails
                              ?.cancellationStatus || "Pending"}
                          </p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Charge Date</h6>
                          <p>
                            {bookingData?.cancellationDetails?.chargeDate
                              ? formatDubaiDateTime(
                                  bookingData?.cancellationDetails?.chargeDate
                                )
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </>
                  ) : null}

                  {bookingData?.isCancel && isRefund ? (
                    <>
                      <div className="control_group w_100">
                        <hr />
                      </div>
                      <div className="section_title mb_20">
                        <h2>Refund Details</h2>
                      </div>
                      <div className="gap_p view_page">
                        <div className="control_group w_25">
                          <h6>Total Refunded Amount</h6>
                          <p>
                            AED{" "}
                            {bookingData?.refundDetails?.totalRefundAmount ||
                              "0"}
                          </p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Refund Status</h6>
                          <p>
                            {bookingData?.refundDetails?.refundStatus || "-"}
                          </p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Refund Date</h6>
                          <p>
                            {bookingData?.refundDetails?.refundDateTime
                              ? formatDubaiDateTime(
                                  bookingData?.refundDetails?.refundDateTime
                                )
                              : "-"}
                          </p>
                        </div>

                        <div className="control_group w_100">
                          <h6>Individual Refunded Amount</h6>
                          <ul className="guest_list">
                            {bookingData?.refundDetails?.refundDetailslist?.map(
                              (item) => (
                                <li>
                                  <span>{item?.name || "-"}</span>
                                  <strong>
                                    AED {item?.refundAmount || "0"}
                                  </strong>
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                      </div>
                    </>
                  ) : null}
                </>
              ) : null}
            </div>
          </div>

          {bookingData?.bookingUserDetails?.length ? (
            <div className="cards table_cards  mt_30 v2">
              <div className="cards_header p_20">
                <h2>Guest Detail</h2>
              </div>
              <div className="table_wraper">
                <div className="sorting_table">
                  <TableComponent
                    columns={columns}
                    rows={bookingData?.bookingUserDetails?.filter(
                      (item: any) => item?.role !== "Partner"
                    )}
                  />
                </div>
              </div>
            </div>
          ) : null}

          {bookingData?.offerDetails?.offerType ===
          OFFER_TYPE.CONTACT_DEALERS ? (
            <div className="cards table_cards v2">
              <div className="cards">
                <div className="section_title">
                  <h2>Payment Details</h2>
                </div>
                <div className="gap_p view_page">
                  <div className="control_group w_25">
                    <h6>Amount</h6>
                    <p>{`AED ${bookingData?.contactDealerAmount || "0"}`}</p>
                  </div>
                  <div className="control_group w_50">
                    <h6>Description</h6>
                    <p>
                      {bookingData?.contactDealerNotes ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: bookingData?.contactDealerNotes,
                          }}
                        />
                      ) : (
                        <p>-</p>
                      )}
                    </p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Status</h6>
                    <p>-</p>
                  </div>
                  <div className="control_group w_25">
                    <h6>Date & Time</h6>
                    <p>-</p>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          {bookingData?.offerDetails?.offerType === OFFER_TYPE.EVENTS &&
          bookingData?.refunduserDetails?.length
            ? bookingData?.refunduserDetails?.map((item) => {
                return (
                  <div className="cards table_cards v2">
                    <div className="cards">
                      <div className="section_title">
                        <h2>
                          {item?.role === "Guest"
                            ? "Guest Details"
                            : "Partner Details"}
                        </h2>
                      </div>
                      <div className="gap_p view_page">
                        <div className="control_group w_25">
                          <h6>Name</h6>
                          <p>{item?.name || "-"}</p>
                        </div>
                        <div className="control_group w_50">
                          <h6>Email</h6>
                          <p>{item?.email || "-"}</p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Phone Number</h6>
                          <p>-</p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Amount</h6>
                          <p>AED {item?.amount || "0"}</p>
                        </div>
                        <div className="control_group w_25">
                          <h6>Payment Status</h6>
                          <p>
                            {item?.paymentStatus ===
                            REFUND_STATUS.REFUND_PENDING
                              ? "Refund Pending"
                              : item?.paymentStatus}
                          </p>
                        </div>

                        {item?.paymentStatus ===
                        REFUND_STATUS.REFUNDED ? null : (
                          <div className="control_group w_100">
                            <Button
                              className="btn btn_primary"
                              onClick={() => {
                                setRefundOpen(true);
                                setRefundAmount(String(item?.amount));
                                setGuestRole(item?.role);
                                setGuestEmail(item?.email);
                              }}
                            >
                              Refund
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs1} index={1}>
          <BookingRsvpTable notesData={notesData} />

          {notesData?.length ? (
            <CustomPagination
              currentPage={page - 1}
              totalPages={Math.ceil(count / 10)}
              count={count}
              pageSize={10}
              onPageChange={(page) => setPage(page + 1)}
            />
          ) : null}
        </CustomTabPanel>

        <AddNote
          open={open1}
          onClose={handleCloseModal1}
          setOpen={setOpen1}
          bookingId={id}
        />
      </MainContainer>

      <Modal
        className="modal addCategory_modal"
        open={refundOpen}
        onClose={onRefundClose}
      >
        <div className="modal-dialog">
          <div className="modal-body">
            <div className="modal_title">
              <h2>Refund</h2>
              <div
                className="btn-close"
                role="button"
                tabIndex={0}
                onClick={() => {
                  setRefundOpen(false);
                }}
              >
                <CloseIcon />
              </div>
            </div>
            <form className="form">
              <div className="control_group">
                <label htmlFor="amount">Amount</label>
                <TextField
                  placeholder="Enter amount"
                  id="amount"
                  fullWidth
                  hiddenLabel
                  inputProps={{ maxLength: 10 }}
                  value={refundAmount}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (isValidNumber(value)) {
                      setRefundAmount(value);
                    }
                  }}
                />
                {error && !refundAmount ? (
                  <p className="err_msg">Amount is required</p>
                ) : (
                  ""
                )}
              </div>

              <div className="footer_btn_flex">
                <Button
                  className="btn btn_primary"
                  onClick={() => refundGuestApi()}
                >
                  Submit
                </Button>
              </div>
            </form>
          </div>
        </div>
      </Modal>

      <CancelEventModal
        open={openModal4}
        onClose={() => setOpenModal4(false)}
        setOpen={setOpenModal4}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
        offerId=""
        getOfferDetailApi={() => {}}
      />
      <DietaryRequirements
        open={openModal5}
        onClose={() => setOpenModal5(false)}
        setOpen={setOpenModal5}
      />
    </>
  );
}

export default RsvpBookingDetail;
